/**
 * Tailwind classes for `ErrorState`, built only from the tokens in
 * `src/styles/globals.css`.
 *
 * `bg-surface-raised`, not `bg-surface`: the content canvas is `surface-sunken`,
 * so a card must sit one step ABOVE it to read as raised. `surface` is the
 * chrome tone (sidebar, top bar) and equals the canvas' neighbour, which made
 * this card look like a hole rather than a panel.
 */
export const errorStateStyles = {
  root: 'flex flex-col items-center justify-center gap-2 rounded-surface border border-border bg-surface-raised px-6 py-10 text-center',
  title: 'text-sm font-medium text-content',
  message: 'text-sm text-critical',
  retry:
    'mt-2 rounded-control border border-border-strong bg-surface-raised px-3 py-1.5 text-sm font-medium text-content hover:bg-surface-sunken',
} as const;
